<!--
TODO
Network Information api
Battery api
-->
<template>
<div>
  <v-system-bar app dark class="topbar" v-bind:class="{fullscreen,isphone:$vuetify.breakpoint.smAndDown}">
    <span style="z-index:1;padding-left:10px;" @click="clickMenuText">{{ $vuetify.breakpoint.smAndDown?"Menu":"Activities" }}</span>&nbsp;&nbsp;
    <span style="z-index:1">{{$route.name}}</span>
    <v-spacer></v-spacer>
    <span v-if="$vuetify.breakpoint.smAndDown" style="z-index:2">
      <!-- <v-icon>network_cell</v-icon> -->
      <v-icon>network_wifi</v-icon>
      <v-icon>volume_up</v-icon>
      <!-- <i class="fas fa-battery-empty"></i>
      <i class="fas fa-battery-quarter"></i>
      <i class="fas fa-battery-half"></i>
      <i class="fas fa-battery-three-quarters"></i>
        NOTE if you want to use fa then you should be able to use it with fa prefix <v-icon>fa-iconname</v-icon>
     -->
      <i class="fas fa-battery-full"></i>&nbsp;
    </span>
    <div v-bind:class="{'clockcenter':!$vuetify.breakpoint.smAndDown}"><span @click="clickTime" id="time"></span></div>
    <v-menu v-if="!$vuetify.breakpoint.smAndDown" class="topmenuopener" :close-on-content-click="false" v-model="showmenu" dark bottom offset-y content-class="boxtrmenu">
      <span slot="activator" style="z-index:2">
        &nbsp;
        <v-icon>network_wifi</v-icon>
        <v-icon>volume_up</v-icon>
        <v-icon>battery_full</v-icon>
        <v-icon>arrow_drop_down</v-icon>
      </span>
      <Settings class="titlebarmenu" @bricha="$emit('bricha',$event)"></Settings>
    </v-menu>
  </v-system-bar>
</div>
</template>

<script>
import Settings from '../partials/Settings.vue'

export default {
  name: "TitleBar",
  components: {
    Settings
  },
  data() {
    return {
      days: new Array('Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'),
      showmenu: false
    }
  },
  props: {
    fullscreen: {
      default: false
    }
  },
  methods: {
    // popMenu() {
    //   this.showmenu = !this.showmenu;
    // },
    clickMenuText() {
      this.$emit('tdr');
    },
    clickTime() {
      this.$fullscreen.toggle(document.body, {
        wrap: false
      })
    },
    showTime() {
      var datum = new Date;
      var h = datum.getHours();
      var m = datum.getMinutes();
      if (h < 10) {
        h = "0" + h;
      }
      if (m < 10) {
        m = "0" + m;
      }
      document.getElementById("time").innerHTML = (this.$vuetify.breakpoint.smAndDown ? '' : this.days[datum.getDay()] + ' ') + h + ':' + m;
      return true;
    }
  },
  mounted: function() {
    this.showTime();

    this.interval = setInterval(function() {
      this.showTime();
    }.bind(this), 1000);
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  }
}
</script>
<style>
.topmenuopener .v-menu__activator--active {
  border-bottom: 2px solid #E95420;
}

.v-menu__activator{
  cursor: default;
}

.topmenuopener>* {
  transition: all 0.1s easeInOut;
  /* border-bottom: 2px solid transparent; */
  padding-right: 10px;

  /* verschiebt in y direction aendert aber groesse nicht lol */
  font-size: 95%;

}

.topmenuopener {
  height: 23px;
}


.boxtrmenu {
  box-shadow: none;
  /* Weird calculation, fix through own positioning */
  left: auto !important;
  right: 0px;
}

.titlebarmenu {
  background-color: #3f3e39;
  margin-right: 10px;
  margin-top: 15px;
  border-radius: 3px;
  color: #eeeeec;
}

.titlebarmenu::before {
  position: absolute;
  content: '';
  top: 5px;
  right: 35px;
  height: 0px;
  width: 0px;

  border-width: 0 10px 10px 10px;
  border-style: solid;
  border-color: #3f3e39 transparent;
}

.clockcenter {
  text-align: center;
  position: absolute;
  width: 100%;
}

#time {
  padding-right: 10px;
}

.clockcenter#time {
  padding-left: 10px;
  /* center on normal */
}

.topbar {
  background-color: rgba(0, 0, 0, 0.2) !important;
  /* padding: 12px 0px 14px 10px; */
  padding: 0px;
  font-size: 110%;

  /* Bug fix, system-bar--fixed get automatically added */
  /* position: initial; */
  position: relative;

  /* This doesnt work, we have gradients */
  transition: all 0.5s ease;
}


.topbar.fullscreen {
  background: #58554d;
  background: -moz-linear-gradient(top, #58554d 0%, #3f3e39 100%);
  background: -webkit-linear-gradient(top, #58554d 0%, #3f3e39 100%);
  background: linear-gradient(to bottom, #58554d 0%, #3f3e39 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#58554d', endColorstr='#3f3e39', GradientType=0);
}

.topbar.isphone {
  background: rgba(0, 0, 0, 1) !important;
}

.topbar:not(.isphone) span:hover,
.topbar:not(.isphone) span:hover>* {
  color: white !important;
}

.topbar,
.topbar span,
.topbar span>* {
  color: #cccccc !important;
  cursor: default;
  transition: all 0.1s ease;
}
</style>



// WEBPACK FOOTER //
// src/partials/TitleBar.vue